/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartLine = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M4 20v-1.3l6-2.1 5.4 1.9 5.7-.5-.2-2-5.3.5-5.6-2.1-6 2.2v-3.7l1.9 1.2 5.8-2.6 9.2 1 .2-2-9.8-1-5.2 2.4L4 10.5V6.8l4.1 2.4 3.1-2.5 3.3 1.4 6.9-2.7-.8-1.8-6.1 2.3-3.7-1.6-2.9 2.5L4 4.4V2H2v20h20v-2z"
    />
  </Icon>
);
export { SvgChartLine as ChartLine };
